(() => {
  const SELECTOR_ADDON_CHECKED = '.product-addons .addon-checkbox:checked';

  const getAddonVariantIds = () => {
    return Array.from(document.querySelectorAll(SELECTOR_ADDON_CHECKED))
      .map(cb => cb.getAttribute('data-addon-variant-id'))
      .filter(Boolean);
  };

  const findCartAddForm = (clickedEl) => {
    if (clickedEl) {
      const form = clickedEl.closest('form[action*="/cart/add"]');
      if (form && form.querySelector('input[name="id"]')) return form;
    }

    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    return forms.find(f => f.querySelector('input[name="id"]')) || null;
  };

  const getMainVariantId = (form) => {
    return form?.querySelector('input[name="id"]')?.value || null;
  };

  const getQty = (form) => {
    const raw = form?.querySelector('input[name="quantity"]')?.value;
    const n = raw ? parseInt(raw, 10) : 1;
    return Number.isFinite(n) && n > 0 ? n : 1;
  };

  const addItems = async (items) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    const data = await res.json();
    if (!res.ok) throw data;
    return data;
  };

  const shouldTakeOver = () => getAddonVariantIds().length > 0;

  const handle = async (e, clickedEl) => {
    if (!shouldTakeOver()) return;

    const form = findCartAddForm(clickedEl);
    const mainId = getMainVariantId(form);
    if (!form || !mainId) return;

    // TAKE OVER before Savor / apps
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    const qty = getQty(form);
    const addonIds = getAddonVariantIds();

    const groupId =
      'ynv_' + Date.now() + '_' + Math.random().toString(16).slice(2);

    const items = [
      {
        id: mainId,
        quantity: qty,
        properties: {
          _ynv_group: groupId,
          _ynv_role: 'parent'
        }
      },
      ...addonIds.map(id => ({
        id,
        quantity: 1, // keep 1 for cards/chocolates (recommended)
        properties: {
          _ynv_group: groupId,
          _ynv_role: 'addon'
        }
      }))
    ];

    try {
      await addItems(items);
      window.location.href = '/cart';
    } catch (err) {
      console.error('[YNV Add-ons] cart/add error', err);
      alert(
        err.description ||
        err.message ||
        'Could not add add-ons. Please try again.'
      );
    }
  };

  // Capture ALL add-to-cart submits
  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || !form.action.includes('/cart/add')) return;
      handle(e, form);
    },
    true
  );

  // Capture ALL add-to-cart clicks (Savor-safe)
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest(
        'button[type="submit"], input[type="submit"], [data-add-to-cart], .add-to-cart'
      );
      if (!btn) return;
      handle(e, btn);
    },
    true
  );
    (() => {
    /**
     * YNV Safety Net:
     * If a parent item is removed (or missing), remove any add-ons sharing the same _ynv_group.
     *
     * Requires cart row <tr> to include:
     *  - data-key
     *  - data-ynv-role
     *  - data-ynv-group
     */

    const CHANGE_ENDPOINT = `${window.Shopify?.routes?.root || '/'}cart/change.js`;
    const CART_ENDPOINT = `${window.Shopify?.routes?.root || '/'}cart.js`;

    let cleanupInFlight = false;
    let scheduled = false;

    const postJSON = async (url, payload) => {
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw data;
      return data;
    };

    const getCart = async () => {
      const res = await fetch(CART_ENDPOINT, { headers: { 'Accept': 'application/json' } });
      return res.json();
    };

    const removeLineByKey = async (key) => {
      // Shopify supports passing the line item "key" as id to /cart/change.js
      return postJSON(CHANGE_ENDPOINT, { id: key, quantity: 0 });
    };

    const scheduleCleanup = () => {
      if (scheduled) return;
      scheduled = true;
      // run after the theme finishes its own cart updates
      setTimeout(() => {
        scheduled = false;
        cleanupOrphanAddons().catch((e) => console.error('[YNV Safety Net] cleanup error', e));
      }, 350);
    };

    const cleanupOrphanAddons = async () => {
      if (cleanupInFlight) return;
      cleanupInFlight = true;

      try {
        const cart = await getCart();
        const items = Array.isArray(cart?.items) ? cart.items : [];

        // Build set of groups that still have a parent present
        const parentGroups = new Set(
          items
            .filter((it) => it?.properties?._ynv_role === 'parent' && it?.properties?._ynv_group)
            .map((it) => it.properties._ynv_group)
        );

        // Find add-ons whose group has no parent
        const orphanAddons = items.filter((it) => {
          const role = it?.properties?._ynv_role;
          const group = it?.properties?._ynv_group;
          return role === 'addon' && group && !parentGroups.has(group);
        });

        if (!orphanAddons.length) return;

        // Remove orphans by their line item key
        for (const orphan of orphanAddons) {
          if (orphan?.key) {
            await removeLineByKey(orphan.key);
          }
        }

        // Refresh UI reliably (Savor uses dynamic cart rendering; reload is the safest universal sync)
        window.location.reload();
      } finally {
        cleanupInFlight = false;
      }
    };

    // 1) If user clicks remove on ANY cart item, let theme do its thing, then sweep.
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.cart-items__remove, [on\\:click*="onLineItemRemove"]');
      if (!btn) return;

      // If the removed item is a parent OR could affect grouping, sweep after update
      const row = btn.closest('tr[data-key]');
      if (!row) return;

      const role = row.getAttribute('data-ynv-role');
      const group = row.getAttribute('data-ynv-group');

      // Only schedule for parent removal (or if missing data, still safe to sweep)
      if (!role || role === 'parent' || group) {
        scheduleCleanup();
      }
    }, true);

    // 2) If user quantity is changed to 0 via inputs/buttons, sweep after update.
    document.addEventListener('change', (e) => {
      const qtyInput = e.target.closest('input[name="quantity"], input[data-quantity-input]');
      if (!qtyInput) return;

      const row = qtyInput.closest('tr[data-key]');
      if (!row) return;

      const role = row.getAttribute('data-ynv-role');
      const group = row.getAttribute('data-ynv-group');

      // Only sweep when parent group might be impacted
      if (!role || role === 'parent' || group) {
        scheduleCleanup();
      }
    }, true);

    // 3) Also sweep once on page load (covers edge cases like cached cart state)
    window.addEventListener('load', () => {
      scheduleCleanup();
    });
  })();

})();
